import { Component, OnInit, Input, HostBinding, AfterViewInit, OnDestroy, Directive, HostListener, Inject, DOCUMENT } from '@angular/core';
import * as _ from 'underscore';
import { MenuService } from './menu.serive';
import { MENU_ICON, HttpLoader, AlertPopup, config, path } from './../../app.config';
import { SettingsService } from './../settings/settings.service';
import { DataSharingService } from './../../shared/data-sharing.service';
import { PlayerService } from './../media-player/media-player-service';
import { ChatService } from '../chat-list/chat.service';
import { Router } from '@angular/router';
import { HeaderService } from '../header/header.service';
import { Subject } from 'rxjs';

// import { ELibraryService } from '../e-library/e-library.service';


// @Directive()
@Component({
  selector: 'app-menu-options',
  templateUrl: './menu-options.component.html',
  styleUrls: ['./menu-options.component.scss'],
  standalone: false
})
export class MenuOptionsComponent implements OnInit, AfterViewInit, OnDestroy {
  @HostBinding('class.flex-grid') leftBarClass = true;
  @HostBinding('class.tab-view') tabViewClass = true;
  isUserLoggedIn = false;
  @Input() menuList: any;
  @Input() setting: any;
  // @Input() isUserLoggedIn: boolean;
  @Input() currentUser: any;

  isToken: any;
  isUserRole: any;

  mediaContent: any = null;
  subscribers: any = {};

  menuIcon: any = MENU_ICON;

  activeUserChannelList: any[] = [];
  activeChannel = false;
  singleSelect: any;
  companySearch: any;
  searchInList = new Subject<any>();
  isBelowIpadSize: boolean = false;
  profileUrl = path.PROFILE_URL;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isBelowIpadSize = window.innerWidth <= 768; // Update screen size on resize

  }


  ShowDropdown: boolean = false;


  constructor(
    private router: Router,
    private menuService: MenuService,
    private settingsService: SettingsService,
    private dataSharingService: DataSharingService,
    private chatService: ChatService,
    private headerService: HeaderService,
    private loader: HttpLoader,
    private alert: AlertPopup,
    private playerService: PlayerService,
    @Inject(DOCUMENT) private document: Document,
    // private elibraryService: ELibraryService
  ) {

  }

  ngOnInit() {
    this.isUserLoggedIn = true;
    this.isToken = localStorage.getItem('token');

    if (this.isToken) {
      this.isUserRole = localStorage.getItem('user_role');
      this.isUserRole = parseInt(this.isUserRole.replace(/\"/g, ""));
    }

    this.isBelowIpadSize = window.innerWidth <= 640;

    this.router.events.subscribe(
      (event: any) => {
        let sidebar = this.document.querySelector('.sidebar');

        setTimeout(() => {
          if (sidebar && sidebar.classList.contains('show')) {
            sidebar.classList.remove('show');
          }

          let ngtooltip = this.document.querySelector('.ng-tooltip');
          if (ngtooltip && ngtooltip.classList.contains('ng-tooltip-show')) {
            ngtooltip.classList.remove('ng-tooltip-show');
          }

        }, 300);

      });
  };



  ngAfterViewInit(): void {

    this.subscribers.notifyCount = this.dataSharingService
      .getNotifyCount()
      .subscribe(menuObj => {

        const actualMenuList = [...this.menuList];

        const menu = actualMenuList.find(
          item => item.menu_name === menuObj.menu
        );

        console.log(menu, '-------------------menu----------------------');


        if (!menu) {
          return;
        }

        if (menuObj.count != null) {
          menu.notify_count = menuObj.count;
        } else {
          menu.notify_count = (menu.notify_count || 0) + 1;
        }

        this.menuList = [...actualMenuList];
      });

    this.subscribers.media = this.playerService
      .getMediaContent()
      .subscribe({
        next: (response) => {
          if (!response) {
            return;
          }

          if (!this.mediaContent ||
            this.mediaContent.file_path !== response.file_path) {
            this.mediaContent = response;
          }
        },
        error: (err) => console.error(err)
      });
  }

  urlFormation(menuName: any) {
    if (menuName) {
      return menuName.replace(/_/g, '');
    }
  };


  /**
 * Chang the hide sidemenu style
 * @param value
 */
  hideSideMenu() {
    try {
      const payLaod = {
        visible_sidebar: !this.setting.visible_sidebar
      };
      const settingObj = { ...this.setting }
      settingObj.visible_sidebar = !this.setting.visible_sidebar;
      this.setting = settingObj;
      this.settingsService.updateUserSettings(payLaod).subscribe(
        response => {
        },
        error => {
          console.log(error);
        });
    } catch (err) {
      console.log(err);
    }

    if (this.isBelowIpadSize) {
      let sidebar: any = this.document.querySelector('.sidebar');
      sidebar.classList.toggle('show');
    }

  };

  removeNotifyCount(menuObj: any) {
    menuObj.notify_count = 0;
  };


  ngOnDestroy(): void {
    this.subscribers.notifyCount.unsubscribe();
    this.subscribers.media.unsubscribe();
    this.activeChannel = false;
  }

  showSearchBox(toggle: any) {
    console.log(toggle);

  }

  displayUserFirstLetter(userName: any) {
    if (userName) {
      return userName.charAt(0).toUpperCase();
    } else {
      return;
    }
  }

  showuserMenu() {
    this.ShowDropdown = !this.ShowDropdown;
  }

  logout() {
    const payload = {
      user_id: this.currentUser.user_id,
      status_id: 0
    }

    this.headerService.updateStatus(payload).subscribe(res => {
      window.localStorage.clear();
      this.router.navigate(['/login']);
    });
  }

}
